import { Container, styled } from "@mui/system";
import { Grid, Typography, Paper, TextField, FormControl, Radio, RadioGroup, FormControlLabel, Checkbox, FormGroup } from "@mui/material";
import globals from "../globals";
import RedButton from "../components/redButton";
import React from "react";
import LoadingIcon from "../components/loading";

const images = ['2.webp', '4.webp', '10.webp',]


const TextFieldRequest = styled(TextField)(() => ({
    borderRadius: 3,
    backgroundColor: globals.colors.lightPink, // default background
    '&:hover': {
        backgroundColor: globals.colors.lightPink, // no color on hover
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: 'transparent', // no border by default
        },
        '&:hover fieldset': {
            borderColor: 'transparent', // no border on hover
        },
        '&.Mui-focused fieldset': {
            borderColor: globals.colors.lightRed, // red border when typing
        },
    },
}));


const CheckedCheckbox = styled(Checkbox)(() => ({
    color: globals.colors.darkBlue, // default (unchecked) color
    '&.Mui-checked': {
        color: globals.colors.darkBlue, // checked color
    },
    '&:hover': {
        // boxShadow: '0 0 5px lightcoral', // light red shadow on hover
        backgroundColor: globals.colors.lightGray, // optional: remove hover background
    },
}));

const handleSubmit = () => {
    
}


const InteractiveBook2 = () => {
    const [value, setValue] = React.useState('S');
    const [question1, setQuestion1] = React.useState('');
    const [question2, setQuestion2] = React.useState('');
    const [question3, setQuestion3] = React.useState('');
    const [question4, setQuestion4] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [phoneNumber, setPhoneNumber] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [showMessage, setShowMessage] = React.useState(false);

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        //console.log("question1", question1);
        //console.log("question2", question2);
        //console.log("question3", question3);
        //console.log("question4", question4);
        //console.log("email", email);
        //console.log("phoneNumber", phoneNumber);
        //console.log("value", value);
        setLoading(true);
    fetch(globals.apiUrl + '/courses/form-submission', {
        method: 'POST',
        body: JSON.stringify({ question_1:question1, question_2:question2, question_3:question3, question_4:question4, email, phone_number:phoneNumber, merch_size: value }),
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(response => response.json())
    .then(data => {
        //console.log(data);
        setLoading(false);
        setShowMessage(true);
    })
    .catch(error => {
        console.error('Error:', error);
    })
    }

    return (
        <Container>
            <Grid container justifyContent={'center'} textAlign={'center'} spacing={3}>
                <Grid item xs={12} sm={7}>
                    <Grid container justifyContent={'center'} textAlign={'center'}>
                        <Grid item xs={12} sm={12}>
                            <Typography sx={{ color: globals.colors.lightRed, fontSize: 22, fontWeight: 'bold' }}>Жеравко Драгомански на гости в Япония</Typography>
                        </Grid>
                        <Grid item sx={{ mt: 2 }}>
                            <Typography sx={{ color: globals.colors.darkBlue, fontSize: 18, fontWeight: 'bold' }}>Интерактивна книжка за деца</Typography>
                        </Grid>
                        <Grid item sx={{ mt: 3 }}>
                            <Typography sx={{ color: globals.colors.textColor }}>
                                eAcademiaBg представя второто издание на детската книжка с кауза. Интерактивната книга за деца е написана от Младена Германова, а илюстрациите
                                са направени от нашия екип. Чрез нея искаме да разпространим информация
                                за Драгоманското блато и Сивия жерав. <br /><br />

                                Жеравко Драгомански се завръща, за да ви заведе на пътешествие до Япония, изпълнено с нови приятели, ценни уроци за околната среда
                                и интересни задачки.<br /><br />

                                Можете да изтеглите безплатно pdf версията на книжката, за да научите повече
                                за приключенията на Жеравко Драгомански и да се забавлявате.
                            </Typography>
                            <Grid item>
                                <RedButton href='https://eacademiabg-test.s3.us-east-1.amazonaws.com/%D0%96%D0%B5%D1%80%D0%B0%D0%B2%D0%BA%D0%BE+%D0%94%D1%80%D0%B0%D0%B3%D0%BE%D0%BC%D0%B0%D0%BD%D1%81%D0%BA%D0%B8+%D0%BD%D0%B0+%D0%B3%D0%BE%D1%81%D1%82%D0%B8+%D0%B2+%D0%AF%D0%BF%D0%BE%D0%BD%D0%B8%D1%8F+-+%D0%BA%D0%BD%D0%B8%D0%B6%D0%BA%D0%B0.pdf' text={'Изтегли'} sx={{ mt: 5, fontSize: 18 }} pX={3} />
                            </Grid>
                        </Grid>
                        {/* <Grid item sx={{ mt: 2 }}>
                            <Typography sx={{ color: globals.colors.lightRed, fontWeight: 'bold', mt: 2 }}>Скролнете надолу за възможност да спечелите подарък худи!👇</Typography>
                        </Grid> */}
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={5}>
                    <img src="book_cover.webp" loading="lazy" decoding="async" height={400} width={350} />
                </Grid>
            </Grid>

            <Grid container spacing={5} sx={{ mt: 3 }} justifyContent={'center'}>
                {images.map(img_url => (
                    <Grid item xs={12} sm={4}>
                        <img src={img_url} height={400} width={320} />
                    </Grid>
                ))}
            </Grid>

            {/* <Grid component='form' onSubmit={handleSubmit} container justifyContent={'center'} textAlign={'center'} sx={{ mt: 5 }}>
                <Paper elevation={4} sx={{ p: 5 }}>
                    <Grid item>
                        <Typography sx={{
                            color: globals.colors.darkBlue, fontWeight: 'bold'
                        }}>Прочетете книжката и отговорете на въпросите за възможност да спечелите худи:</Typography>
                    </Grid>
                    <Grid item>
                        <Typography sx={{ mt: 5, color: globals.colors.lightRed, fontWeight: 'bold', mb: 2 }}>1. Какъв вид птица е Жеравко Драгомански?</Typography>
                        <TextFieldRequest required fullWidth value={question1} onChange={(e) => setQuestion1(e.target.value)} />
                    </Grid>
                    <Grid item>
                        <Typography sx={{ mt: 3, color: globals.colors.lightRed, fontWeight: 'bold', mb: 2 }}>2. Къде живее Жеравко Драгомански?</Typography>
                        <TextFieldRequest required fullWidth value={question2} onChange={(e) => setQuestion2(e.target.value)} />
                    </Grid>
                    <Grid item>
                        <Typography sx={{ mt: 3, color: globals.colors.lightRed, fontWeight: 'bold', mb: 2 }}>3. Кой е Танчо?</Typography>
                        <TextFieldRequest required fullWidth value={question3} onChange={(e) => setQuestion3(e.target.value)} />
                    </Grid>
                    <Grid item>
                        <Typography sx={{ mt: 3, color: globals.colors.lightRed, fontWeight: 'bold', mb: 2 }}>4. Кой помага с почистването на блатото?</Typography>
                        <TextFieldRequest required fullWidth value={question4} onChange={(e) => setQuestion4(e.target.value)} />
                    </Grid>
                    <Grid item>
                        <Typography sx={{
                            color: globals.colors.darkBlue, fontWeight: 'bold', mt: 10
                        }}>Въведете данни за контакт:</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography sx={{ mt: 5, color: globals.colors.darkBlue, fontWeight: 'bold', mb: 2 }}>Имейл:</Typography>
                        <TextFieldRequest required fullWidth value={email} onChange={(e) => setEmail(e.target.value)} />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography sx={{ mt: 3, color: globals.colors.darkBlue, fontWeight: 'bold', mb: 2 }}>Телефонен номер:</Typography>
                        <TextFieldRequest required fullWidth value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography sx={{ mt: 3, color: globals.colors.darkBlue, fontWeight: 'bold', mb: 2 }}>Желан размер суитчър:</Typography>
                        <FormControl>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={value}
                                onChange={handleChange}
                            >
                                <FormControlLabel value="S" control={<Radio sx={{ color: globals.colors.darkBlue, '&.Mui-checked': { color: globals.colors.darkBlue } }} />} label="S" />
                                <FormControlLabel value="M" control={<Radio sx={{ color: globals.colors.darkBlue, '&.Mui-checked': { color: globals.colors.darkBlue } }} />} label="M" />
                                <FormControlLabel value="L" control={<Radio sx={{ color: globals.colors.darkBlue, '&.Mui-checked': { color: globals.colors.darkBlue } }} />} label="L" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <img src="hoodie_design.webp" loading="lazy" decoding="async" height={200} width={290} />
                    </Grid>
                    <Grid item>
                        <FormControl sx={{ mt: 1 }} component="fieldset" variant="standard">
                            <FormGroup>
                                <FormControlLabel
                                required
                                    control={
                                        <CheckedCheckbox />
                                    }
                                    label={<Typography sx={{color: globals.colors.darkBlue}}>Съгласявам се с "Политики за поверителност", "Общи условия" и "Политики за бисквитките" на сайта.</Typography>}
                                    sx={{
                                        ".MuiFormControlLabel-asterisk": {
                                            display: 'none',
                                        },
                                        mt: 2
                                    }}
                                />
                            </FormGroup>
                        </FormControl>
                    </Grid>
                    <Grid item sx={{ mt: 5 }}>
                        <RedButton text='Изпрати и участвай' type='submit' />
                    </Grid>
                    <Grid item sx={{ mt: 5 }}>
                        {loading && <LoadingIcon />}
                        {showMessage && <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', mt: 2 }}>Успешно изпратено!🎉</Typography>}
                    </Grid>
                </Paper>
            </Grid> */}

        </Container>
    );
}

export default InteractiveBook2;